import ReactApexChart from "react-apexcharts";
import React, { Component } from "react";
import PersianNumber from "../../../shared/PersianNumber";

export default class SemiCircleProgressbar extends Component {
  state = {
    series: [55],
    options: {
      chart: {
        type: "radialBar",
        offsetY: -20,
        width:400,
        sparkline: {
          enabled: true
        }
      },
      legend: {
        show: false
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,

          track: {
            background: "transparent",
            strokeWidth: "97%",
            margin: 5, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: "#999",
              opacity: 1,
              blur: 2
            }
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: -2,
              fontSize: "33px",
              show: false
            }
          }
        }
      },
      grid: {
        padding: {
          top: -10
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "diagonal2",
          shadeIntensity: 0.9,
          gradientToColors: ["#F1C31F", "#491FF1"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          colorStops: [
            {
              offset: 0,
              color: "#F1C31F",
              opacity: 1
            },
            {
              offset: 30,
              color: "#F1113E",
              opacity: 1
            },
            {
              offset: 80,
              color: "#491FF1",
              opacity: 1
            },
            {
              offset: 100,
              color: "#2058E9",
              opacity: 1
            }
          ]
        }
      },
      labels: ["Average Results"]
    }
  };
  render() {
    return (
      <div className="SemiCircleProgressbar">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="radialBar"
          height={400} 
        />
        <div className="SemiCircleProgressbar--percentage">
          <PersianNumber number={55} />
          %
        </div>
      </div>
    );
  }
}
